module.exports = __webpack_public_path__ + "img/icon.b16a14f1.png";